import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SinglePanelDoubleSchuifSinglePanelProps extends ConfigurationProps {}
const SinglePanelDoubleSchuifSinglePanel: React.FC<
  SinglePanelDoubleSchuifSinglePanelProps
> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SinglePanelDoubleSchuifSinglePanelProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.46, 0, 0);
  const position2 = new Vector3(1.378, 0, 0);
  const position3 = new Vector3(2.295, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([position0, position1, position2, position3]),
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Paneel
        materials={materials}
        position={positions[0]}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
      />
      <Schuif
        materials={materials}
        position={positions[1]}
        rotation={rotation}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
        railSettings={doorSettings?.secondary?.railSettings}
      />
      <Schuif
        materials={materials}
        position={positions[2]}
        index={2}
        frameSettings={doorSettings?.tertiary?.frameSettings}
        railSettings={doorSettings?.tertiary?.railSettings}
      />
      <Paneel
        materials={materials}
        position={positions[3]}
        index={3}
        frameSettings={doorSettings?.quaternary?.frameSettings}
      />
    </group>
  );
};

export default SinglePanelDoubleSchuifSinglePanel;
